module.exports = __webpack_public_path__ + "stratumblue_white_outline_logo.png?7b76d9cdb4744ab874ffee8c27952690";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stratumblue_white_outline_logo.png
// module id = 66
// module chunks = 2